import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { authHeader } from "../../utils/authHeader";
import { API_BASE_URL } from "../../config";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";

import Feed from "../../components/feed/Feed";
import Rewards from "../../components/rewards/Rewards";
import SpaceMediaSidebar from "../../components/SpaceMediaSidebar/SpaceMediaSidebar";
import Navbar from "../../components/navbar/Navbar";
import Rightbar from "../../components/rightbar/Rightbar";
import Sidebar from "../../components/sidebar/Sidebar";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import "./home.scss";

const Home = () => {
  const [view, setView] = useState("feed");
  const { spaceId } = useParams();
  const [space, setSpace] = useState(null);
  const { isMobile } = useMediaQuery();

  // ✅ Mostrar/ocultar barra lateral en móviles
  const [showSidebarMobile, setShowSidebarMobile] = useState(false);
  const toggleSidebar = () => setShowSidebarMobile((prev) => !prev);

  // ✅ En móvil, la galería/documentos del espacio se abre como panel
  // deslizante a pantalla completa en vez de quedar apilada al final.
  const [showMediaMobile, setShowMediaMobile] = useState(false);
  useEffect(() => {
    setShowMediaMobile(false);
  }, [spaceId]);

  useEffect(() => {
    const fetchSpace = async () => {
      if (!spaceId) {
        setSpace(null); // Limpia el espacio al volver al inicio
        return;
      }
      try {
        const res = await axios.get(`${API_BASE_URL}/api/spaces`, {
          headers: { ...authHeader() },
        });
        const found = res.data.spaces.find((s) => s.id === parseInt(spaceId));
        if (found) {
          setSpace({
            id: found.id,
            name: found.name,
            description: found.description,
            image: found.image,
            icon: found.icon,
            userId: found.user?.id,
          });
        }
      } catch (err) {
        console.error("Error al cargar espacio:", err);
      }
    };
    fetchSpace();
  }, [spaceId]);

  // ✅ Mostrar Feed si hay espacio seleccionado
  const renderMainContent = () => {
    if (view === "rewards") {
      return <Rewards />;
    }
    return <Feed space={space} />;
  };

  return (
    <div className="home">
      <Navbar setView={setView} toggleSidebar={toggleSidebar} />
      
      <div className="homeContainer">
        <Sidebar
          showSidebarMobile={showSidebarMobile}
          toggleSidebar={toggleSidebar}
          setView={setView}
        />
        <div className="mainContent">
          {renderMainContent()}
        </div>

        {/* ✅ Mostrar SpaceMediaSidebar si hay spaceId, sino Rightbar normal.
            En móvil, la galería no se apila en el layout: se abre como panel
            a pantalla completa desde el botón flotante de abajo. */}
        {spaceId && space ? (
          !isMobile && <SpaceMediaSidebar spaceId={parseInt(spaceId)} spaceName={space.name} />
        ) : (
          !isMobile && <Rightbar />
        )}
      </div>

      {spaceId && space && isMobile && (
        <>
          <button
            className="mobile-media-fab"
            onClick={() => setShowMediaMobile(true)}
            aria-label="Ver galería y documentos del espacio"
          >
            <PhotoLibraryIcon fontSize="small" />
            <span>Galería</span>
          </button>
          {showMediaMobile && (
            <SpaceMediaSidebar
              spaceId={parseInt(spaceId)}
              spaceName={space.name}
              mobileOpen
              onCloseMobile={() => setShowMediaMobile(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Home;
